import React, { Component } from 'react'
import { Provider } from 'react-redux'
import Loadable from 'react-loadable'
import { AppContainer } from 'react-hot-loader'
import { ConnectedRouter } from 'connected-react-router'

/// components
import Login from './components/Login/Login'
import MobileRouting from './components/mobileRouting/MobileRouting'
import SSOLogin from './components/SSOLogin/SSOLogin'
import Logout from './components/Logout/Logout'
import VerifyEmail from './components/VerifyEmail/VerifyEmail'
import RequestResetPasswordEmail from './components/RequestResetPasswordEmail/RequestResetPasswordEmail'
import ResetPassword from './components/ResetPassword/ResetPassword'
import LoadingSpinner from './components/Shared/Loading/LoadingSpinner'
import NewSignup from './components/Signup/NewSignup'

/// HoCs
import { requireAuth } from './hocs/Authentication'
import { Route, Switch } from 'react-router-dom'
import AuthProvider from '@auth/auth-provider'

import { ConfigProvider, notification } from 'antd'
import enUS from 'antd/lib/locale-provider/en_US'

import Signup from './components/Signup/Signup'
import Register from './components/Signup/Register'

const LoadablePlatform = Loadable({
  loader: () => import('./components/Platform/Platform'),
  loading: LoadingSpinner,
})

class App extends Component {
  componentDidMount() {
    notification.config({ duration: 7 })
  }

  render() {
    const { history, store } = this.props
    // TODO: Remove /register once new sign up flow is complete
    return (
          <AppContainer>
            <ConfigProvider locale={enUS}>
              <Provider store={store}>
                <ConnectedRouter history={history}>
                  <Switch>
                    <Route path='/mobile-routing' component={MobileRouting} />
                    <Route>
                      <AuthProvider>
                        <Switch>
                          <Route path='/signup' component={NewSignup} />
                          <Route exact path='/register' component={Signup} />
                          <Route exact path='/register-v2' component={Register} />
                          <Route exact path='/login' component={Login} />
                          <Route exact path='/sso-login' component={SSOLogin} />
                          <Route exact path='/logout' component={Logout} />
                          <Route exact path='/users/verify-email/:token' component={VerifyEmail} />
                          <Route exact path='/users/reset-password' component={RequestResetPasswordEmail} />
                          <Route exact path='/users/reset-password/:token' component={ResetPassword} />
                          <Route path='/' component={requireAuth(LoadablePlatform)} />
                        </Switch>
                      </AuthProvider>
                    </Route>
                  </Switch>
                </ConnectedRouter>
              </Provider>
            </ConfigProvider>
          </AppContainer>
    )
  }
}

export default App
